import React from 'react';
import { NavLink } from 'react-router-dom';


const Footer = () => {
    return (
        <>


            <footer className="footer_area section_padding_130_0">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                             <div className="full py-2 text-center text-white">
                                <p>© 2017 - 2022 Privacy policy Manage & HELMONET</p>
                             </div>
                        </div>
                    </div>
                </div>
            </footer>

        </>
    )
}

export default Footer;
